import React from 'react'
import Layout from '../../components/layouts/Layout'
import InventoryLayout from '../../components/layouts/InventoryLayout'
import { Outlet } from 'react-router-dom'

const Inventory = () => {
  return (
    <Layout pageTitle={`Inventory`}>
        <InventoryLayout>
            <Outlet />
        </InventoryLayout>
    </Layout>
  )
}

export default Inventory